var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kf-btn",on:{"click":_vm.contactKf}},[_c('img',{staticClass:"icon-kf",attrs:{"src":require("@/assets/static/img/icon-kefu.png"),"alt":""}}),_c('div',{staticClass:"kf-txt"},[_vm._v("在线客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }